import styled, { css } from 'styled-components';
import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const BoxHeader = styled.div`
    width: 100%;
    height: 88px;
    background-color: ${COLOR.GREEN_1};
`;

export const ContainerOptions = styled.div`
  width: 100%;
  max-width: 616px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: ${({ align }) => (align ? 'space-between' : 'center')};
  padding: 24px 18px;
  margin: 0 auto;
  div {
    color: ${COLOR.WHITE_1};
    p:first-child {
      font-size: 14px;
      margin-bottom: 7px;
    }
    p {
      font-size: 16px;
    }
    img {
      width: 16px;
      height: 10px;
      margin-left: 6px;
      cursor: pointer;
    }
    label {
      cursor: pointer;
    }
    ${({ visible }) => !visible && css`
      .calculated_value {
        height: 11px;
        background: #CBE4E3;
        border-radius: 2px;
        color: transparent;
      }
      img {
        width: 20px;
        height: 12px;
      }
    `}
  }
  img {
    width: 99px;
    height: 28px;
  }
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    h1 {
      font-size: 20px;
    }
  }
  /* Desktop */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    h1 {
      font-size: 22px;
    }
  }
`;

export const BoxUser = styled.div`
    position: absolute;
    min-width: 135px;
    max-width: 45%;
    height: 36px;
    left: 18px;
    top: 70px;
    background: ${({ recoverPhone }) => (recoverPhone ? `${COLOR.WHITE_1}` : '#FBFBFB')};
    box-shadow: 0px 1px 1px rgba(31, 42, 71, 0.15);
    border-radius: 5px;
    padding: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    label {
        font-family: Roboto;
        font-size: 14px;
        line-height: 16px;
        color: #1F2A47;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 5px;
        /* Tablet-Notebook */
        @media screen and (min-width: ${BREAKPOINT.MD}) {
          font-size: 16px;
        }
        /* Desktop */
        @media screen and (min-width: ${BREAKPOINT.LG}) {
          font-size: 18px;
        }
    }
`;

export const BoxOptions = styled.div`
    position: absolute;
    width: 36px;
    height: 36px;
    right: 18px;
    top: 70px;
    background: ${({ recoverPhone }) => (recoverPhone ? `${COLOR.WHITE_1}` : '#FBFBFB')};
    box-shadow: 0px 1px 1px rgba(31, 42, 71, 0.15);
    border-radius: 5px;
    padding: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
